import { makeStyles } from '@material-ui/core/styles';

export const useFormTobaccoProductStyles = makeStyles(theme => ({
  formProduct: {
    flexGrow: 1
  },
  textarea: {
    height: '100%',
    '& .MuiFormControl-root': {
      height: '100%'
    },
    '& .MuiOutlinedInput-multiline': {
      height: '100%',
      padding: '20px 14px'
    },
    '& .MuiOutlinedInput-multiline textarea': {
      lineHeight: '1.5rem',
      height: '100%'
    }
  }
}));
